import React from 'react'
import { createRoot } from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import App from './App'

import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter } from 'react-router-dom'

import './i18n'
import './timeAgo'
import CurrencyContext from './components/Currency'
import { getCurrency, setCurrency } from './controllers/currency.controller'

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CurrencyContext.Provider value={{
        currency: getCurrency(),
        setCurrency
      }}
      >
        <App />
      </CurrencyContext.Provider>
    </BrowserRouter>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (process.env.REACT_APP_MODE === 'dev') {
  reportWebVitals(console.log)
}
